<script>
import CabecalhoRelatorio from './CabecalhoRelatorio.vue';

export default {
  components: { CabecalhoRelatorio },
  props: {
    dados: {
      type: Array,
      required: true,
    },
    projeto: {
      type: Object,
      required: true,
    },
    titulo: {
      type: String,
      required: true,
    }
  },
  data() {
    return { RELATORIO_COMPRAS_LICITACOES: '7' }
  },
  methods: {
    detalhar(id) {
      this.$router.push({
        name: 'transparencia.projetos.detalhar-compra-licitacao',
        query: this.$route.query,
        params: { id: this.$route.params.id, idPedidoCompra: Number.parseInt(id) }
      });
    },
  },
}
</script>

<template>
  <div>
    <cabecalho-relatorio :titulo="titulo" :nomeProjeto="projeto.nomeProjeto" borda=""></cabecalho-relatorio>

    <div class="table-responsive">
      <table class="table relatorio table-bordered table-striped">
        <thead>
          <tr>
            <th>Data pedido</th>
            <th>Compra/Licitação</th>
            <th>Pedido</th>
            <th>CNPJ fornecedor</th>
            <th>Razão social fornecedor</th>
            <th>Valor total pedido&nbsp;(R$)</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="lancamento in dados" :key="lancamento.idPedidoCompra" class="linha-clicavel">
            <td @click="detalhar(lancamento.idPedidoCompra)">{{ lancamento.data | formatarData }}</td>
            <td @click="detalhar(lancamento.idPedidoCompra)">{{ lancamento.solicitacaoCompra + " - " +
              lancamento.compraLicitacao}}</td>
            <td @click="detalhar(lancamento.idPedidoCompra)">{{ lancamento.numeroPedidoCompra || '---' }}</td>
            <td @click="detalhar(lancamento.idPedidoCompra)">{{ lancamento.cpfcnpj }}</td>
            <td @click="detalhar(lancamento.idPedidoCompra)">{{ lancamento.nomePessoaFisicaJuridica }}</td>
            <td @click="detalhar(lancamento.idPedidoCompra)" :class="'text-right'">{{ lancamento.valor | formatarNumero
              }}</td>
          </tr>
          <tr v-if="dados.length === 0">
            <td colspan="7" class="text-center">Não há dados.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<style>
.linha-clicavel {
  transition: background-color 0.2s;
}

.linha-clicavel:hover {
  background-color: #f8f9fa; 
  color: #0066cc; 
  text-decoration: none; 
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// FrontEnd/modulos/transparencia/componentes/compartilhado/RelatorioComprasLicitacoes.vue